import React from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const SignOut = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  signOut().then(() => {
    navigate("/auth/sign-in");
  });

  return <div />;
};

export default SignOut;
